export default function calculateHeroLevel(domainSlug, estimations) {
  return Math.round((estimations[domainSlug] || 0.1) * 10);
}
